import { render, staticRenderFns } from "./CreateTicket.vue?vue&type=template&id=309db9ce&scoped=true"
import script from "./CreateTicket.vue?vue&type=script&lang=js"
export * from "./CreateTicket.vue?vue&type=script&lang=js"
import style0 from "./CreateTicket.vue?vue&type=style&index=0&id=309db9ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309db9ce",
  null
  
)

export default component.exports